"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../util/colors");
var layout_1 = require("../util/layout");
var Circle_1 = __importDefault(require("./Circle"));
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var animationDuration = 350;
var swipeLength = 100;
var Item = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  opacity: ", ";\n  transition: opacity ", "ms ease;\n  z-index: ", ";\n"], ["\n  position: ", ";\n  opacity: ", ";\n  transition: opacity ", "ms ease;\n  z-index: ", ";\n"])), function (_a) {
    var visible = _a.visible, transitionOut = _a.transitionOut;
    return visible || transitionOut ? 'relative' : 'absolute';
}, function (_a) {
    var visible = _a.visible, transitionOut = _a.transitionOut;
    return visible && !transitionOut ? 1 : 0;
}, animationDuration, function (_a) {
    var visible = _a.visible, transitionOut = _a.transitionOut;
    return visible || transitionOut ? 0 : -1;
});
var ButtonClean = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  appearance: none;\n  outline: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n"], ["\n  appearance: none;\n  outline: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n"])));
var rightArrow = (react_1.default.createElement("svg", { width: "11", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M1.668 19l8-9-8-9", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
var leftArrow = (react_1.default.createElement("svg", { width: "11", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M9.332 1l-8 9 8 9", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
var Carousel = function (_a) {
    var items = _a.items;
    var _b = (0, react_1.useState)(0), current = _b[0], setCurrent = _b[1];
    var _c = (0, react_1.useState)(null), transitioningOut = _c[0], setTransitioningOut = _c[1];
    var _d = (0, react_1.useState)(null), touchStartX = _d[0], setTouchStartX = _d[1];
    var _e = (0, react_1.useState)(null), touchEndX = _e[0], setTouchEndX = _e[1];
    var change = (0, react_1.useCallback)(function (offset) {
        var next = current + offset < 0 ? items.length + offset : current + offset;
        next = next % items.length;
        setTransitioningOut(current);
        setTimeout(function () {
            setCurrent(next);
            setTransitioningOut(null);
        }, animationDuration);
    }, [current, items, setCurrent, setTransitioningOut]);
    var handleTouchEnd = (0, react_1.useCallback)(function () {
        if (!touchStartX || !touchEndX)
            return;
        if (touchEndX - touchStartX > swipeLength) {
            change(-1);
        }
        if (touchEndX - touchStartX < -1 * swipeLength) {
            change(1);
        }
        setTouchStartX(null);
        setTouchEndX(null);
    }, [touchStartX, setTouchStartX, touchEndX, setTouchEndX, change]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: { position: 'relative' } }, items.map(function (item, idx) { return (react_1.default.createElement(Item, { key: idx, visible: current === idx, transitionOut: idx === transitioningOut, onTouchStart: function (e) { return setTouchStartX(e.targetTouches[0].clientX); }, onTouchMove: function (e) { return setTouchEndX(e.targetTouches[0].clientX); }, onTouchEnd: function (e) { return handleTouchEnd(); } }, item)); })),
        react_1.default.createElement(grid_1.Container, { pt: 5, center: true },
            react_1.default.createElement(spacing_1.Div, { pr: 2 },
                react_1.default.createElement(ButtonClean, { onClick: function () { return change(-1); }, name: "previous" },
                    react_1.default.createElement(Circle_1.default, { color: colors_1.colors.primary700, size: (0, layout_1.space)(5) }, leftArrow))),
            react_1.default.createElement(typography_1.P, { center: true, style: { width: '45px' } },
                current + 1,
                " of ",
                items.length),
            react_1.default.createElement(spacing_1.Div, { pl: 2 },
                react_1.default.createElement(ButtonClean, { onClick: function () { return change(1); }, name: "next" },
                    react_1.default.createElement(Circle_1.default, { color: colors_1.colors.primary700, size: (0, layout_1.space)(5) }, rightArrow))))));
};
exports.default = Carousel;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Carousel.js.map